/**
 * This component patches Node.prototype methods to handle Google Translate DOM manipulation errors.
 * When Google Translate modifies the DOM, it can cause React to fail when trying to remove or insert nodes
 * because the nodes' parent relationships get broken. This patch gracefully handles these cases by
 * checking parent relationships before DOM operations and returning early if they're invalid.
 *
 * @see https://github.com/facebook/react/issues/11538#issuecomment-417504600
 */

'use client';

import { useEffect } from 'react';

export function DOMErrorProtection() {
  useEffect(() => {
    if (typeof Node === 'function' && Node.prototype) {
      const originalRemoveChild = Node.prototype.removeChild;
      Node.prototype.removeChild = function <T extends Node>(child: T): T {
        if (child.parentNode !== this) {
          // if (console) {
          //   console.error(
          //     'Cannot remove a child from a different parent',
          //     child,
          //     this
          //   );
          // }
          return child;
        }
        return originalRemoveChild.call(this, child) as T;
      };

      const originalInsertBefore = Node.prototype.insertBefore;
      Node.prototype.insertBefore = function <T extends Node>(
        newNode: T,
        referenceNode: Node | null
      ): T {
        if (referenceNode && referenceNode.parentNode !== this) {
          // if (console) {
          //   console.error(
          //     'Cannot insert before a reference node from a different parent',
          //     referenceNode,
          //     this
          //   );
          // }
          return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
      };
    }
  }, []);

  return null;
}
